import Head from 'next/head';
import React from 'react';

export const BrothersFavicon = () => (
    <>
    <Head>
        <meta name="theme-color" content="#fff" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="application-name" content="Brothers" />
        <meta name="apple-mobile-web-app-title" content="Brothers" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link rel="manifest" href="/assets/brothers-favicon/manifest.webmanifest" />
        <link rel="icon" type="image/x-icon" href="/assets/brothers-favicon/favicon.ico" />
        <link rel="icon" type="image/svg+xml" href="/assets/brothers-favicon/favicon.svg" />
        <link rel="icon" type="image/png" sizes="96x96" href="/assets/brothers-favicon/favicon-96x96.png" />
        <link rel="apple-touch-icon" href="/assets/brothers-favicon/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/assets/brothers-favicon/web-app-manifest-192x192.png" />
        <link rel="icon" type="image/png" sizes="512x512" href="/assets/brothers-favicon/web-app-manifest-512x512.png" />
    </Head>
    </>

);
